import {post} from './HttpClient';
import {API_POST_QUERY_MESSAGE_CHATGPT} from './ApisRoutes';

export const PostMessageToChatGPT = params => {
  return new Promise((resolve, reject) => {
    post(API_POST_QUERY_MESSAGE_CHATGPT, params)
      .then(response => {
        const data = response?.data;
        resolve(data);
      })
      .catch(error => {
        console.log(error, 'dates response error');
        reject(error);
      });
  });
};
